import './LuckyWheel.less';

import React, { useEffect, useState } from 'react';
import WheelComponent from './WheelComponent';
import win from './sounds/win.mp3';
import lost from './sounds/lost.mp3';
import clsx from 'clsx';
import AnimateHeight from 'react-animate-height';
import LuckyWheelResult from './LuckyWheelResult';
import { LuckyWheelWinType } from './utils/enums';
import { playAudio } from './utils/utils';
import { clearError, showLuckyWheelError, spinLuckyWheel } from './h&s';
import { dispatch, useReframe } from 'nike-re-framejs';

const LuckyWheel = ({ onPhone, spin, winningSegment, handleClose, handleInfoClick, navigateToWin }) => {
    const [angle, setAngle] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [spinningResult, setSpinningResult] = useState(null);
    const { lwName, lwDescription, segments, spinTime } = spin;
    const { subscribe } = useReframe();
    const error = subscribe(showLuckyWheelError);
    const fontColor = '#FFFFFF';

    useEffect(() => () => dispatch(clearError), []);

    const windowDevicePixelRation = window.devicePixelRatio;
    const devicePixelRatio = windowDevicePixelRation < 2 ? 2 : windowDevicePixelRation;

    const onFinished = winner => {
        setSpinningResult(winner);
        if (winner.winType === LuckyWheelWinType.WIN || winner.winType === LuckyWheelWinType.REPEAT) {
            playAudio(win);
        } else {
            playAudio(lost);
        }
    };

    const actionButtonClick = (e, gameId, winType) => {
        if (winType === LuckyWheelWinType.REPEAT) {
            setSpinningResult(null);
            setAngle(null);
            setDisabled(false);
        } else {
            navigateToWin(e, gameId);
        }
    };

    const handleSpin = () => {
        if (disabled || error) return;
        dispatch(spinLuckyWheel);
        setDisabled(true);
    };

    return segments ? (
        <div className={clsx({ 'lucky-wheel-phone': onPhone })}>
            <div className={clsx('input-div', { mobile: onPhone })}>
                <WheelComponent
                    segments={segments}
                    fontColor={fontColor}
                    devicePixelRatio={devicePixelRatio}
                    onFinished={winner => onFinished(winner)}
                    winningSegment={winningSegment}
                    size={180}
                    spinTime={spinTime}
                    fontSize={25}
                    title={lwName}
                    subTitle={error || lwDescription}
                    onPhone={onPhone}
                    handleInfoClick={handleInfoClick}
                    handleClose={handleClose}
                    angle={angle}
                    setAngle={setAngle}
                    spin={handleSpin}
                    disabled={disabled}
                    error={error}
                />
            </div>
            {spinningResult ? (
                <>
                    <div className="lucky-wheel-backdrop" style={{ opacity: '0.3' }}></div>
                    <AnimateHeight height={!spinningResult ? 0 : 'auto'} duration={5000}>
                        <LuckyWheelResult
                            result={spinningResult}
                            handleClose={handleClose}
                            onPhone={onPhone}
                            actionButtonClick={e =>
                                actionButtonClick(e, spinningResult.winBonusId, spinningResult.winType)
                            }
                        />
                    </AnimateHeight>
                </>
            ) : null}
        </div>
    ) : null;
};

export default LuckyWheel;
